import { render, staticRenderFns } from "./JustStart.vue?vue&type=template&id=2e17f0f6&scoped=true&"
import script from "./JustStart.vue?vue&type=script&lang=js&"
export * from "./JustStart.vue?vue&type=script&lang=js&"
import style0 from "./JustStart.vue?vue&type=style&index=0&id=2e17f0f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e17f0f6",
  null
  
)

export default component.exports